/**
 * Значение — объект, чьи поля можно читать по имени. Нужна там, где форма значения не обещана
 * типом: ответ отказа сервера, выборка из состояния навигации или хранилища браузера.
 */
export const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null;
